<span [innerHTML]="previewContent$ | async | linky"></span>
